import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router";
import { withStyles } from "tss-react/mui";
import { Add, Filter9Plus } from "@mui/icons-material";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import JamezzTable from "../../components/JamezzTable/JamezzTable";
import Button from "../../components/CustomButtons/Button";
import tagsStyle from "../../assets/jss/material-dashboard-pro-react/views/tagsStyle";
import MainNavbar from "../../components/Navbars/MainNavbar";
import * as actions from "../../store/actions";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import TextFilter from "../../components/Filters/TextFilter";

class Index extends React.Component {
  state = {
    selectedIds: [],
    showDeleteAlert: false,
  };

  toggleModal(modal) {
    let newState = { ...this.state };
    newState[modal] = !this.state[modal];
    this.setState(newState);
  }

  hideDeleteAlert = () => {
    this.setState({ showDeleteAlert: false });
  };

  canCreateNieuwItem = () => {
    if (this.props.vestiging_id) {
      return true;
    }
    return false;
  };

  render() {
    const { classes } = this.props;

    return (
      <div>
        <MainNavbar
          paginaTitel={
            <TranslationWrapper tDefault={"Default settings collections"} tKey={"defaultsettings.pagetitle"} />
          }
        />
        <GridContainer>
          <GridItem xs={12}>
            <Link to={"./create"}>
              <Button className={classes.marginRight} color={"success"}>
                <Add className={classes.icons} />{" "}
                <TranslationWrapper tDefault={"New settings collection"} tKey={"defaultsettings.nieuw.item"} />
              </Button>
            </Link>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem md={4} xs={12}>
            <TextFilter
              field={"type"}
              fieldKey={"defaultsettings:type"}
              operator={"like"}
              placeholder={getTranslation("defaultsettings.filter.type", "Filter one settings collection type")}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12}>
            <JamezzTable
              dataMapping={[
                { dbfield: "id", editable: false },
                { dbfield: "type", editable: false },
                { dbfield: "starts", editable: false },
                { dbfield: "ends", editable: false },
              ]}
              dbfields={"id,type,starts,ends"}
              delete={"defaultsettings.delete"}
              editLink={"./:id/edit"}
              editLinkPermission={"defaultsettings/:id/edit"}
              fetchUrl={"core/defaultsettings"}
              filters={this.props.filters}
              headerIcon={<Filter9Plus />}
              headers={[
                {
                  label: getTranslation("defaultsettings.setting.id", "#"),
                  sortable: true,
                  sortKey: "id",
                },
                {
                  label: getTranslation("defaultsettings.setting.type", "Type"),
                  sortable: false,
                  width: "20%",
                  sortKey: "type",
                },
                {
                  label: getTranslation("defaultsettings.setting.starts", "Starts"),
                  sortable: false,
                  width: "20%",
                  sortKey: "starts",
                },
                {
                  label: getTranslation("defaultsettings.setting.ends", "Ends"),
                  sortable: false,
                  width: "20%",
                  sortKey: "ends",
                },
              ]}
              reduxKey={"defaultsettings"}
              tableTitle={
                <TranslationWrapper tDefault={"Default settings collections"} tKey={"defaultsettings.tag.titel"} />
              }
            />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

//REDUX
const mapStateToProps = (state) => {
  if (state.filtersV2["tags:tagName"]) {
    filters["tags:tagName"] = state.filtersV2["tags:tagName"];
  }
  return {
    user_id: state.user.id,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showMessage: (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message }),
    closeMessage: () => dispatch({ type: actions.CLOSE_MESSAGE }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(Index, tagsStyle));
